'use strict';

module.exports = function(filterUpdates, fMetadata, $cachedSelectors) {
    Odigeo._.each(filterUpdates, function(obj) {
        var $cache = $cachedSelectors[obj.cache] || $(obj.cache);
        var elem;
        $cache.each(function() {
            var arr = $(this).val().split('_');
            elem = fMetadata[obj.meta][arr[0]];
            if (arr.length > 1) {
                elem = elem.airports[arr[1]];
            }
            if (!Odigeo._.isUndefined(elem)) {
                $(this).prop('disabled', !elem.visible);
                if (!elem.visible && !Odigeo._.isUndefined(elem.matchedItinerariesCount)) {
                    $(this).toggleClass('hasResults', elem.matchedItinerariesCount > 0);
                }
                if (!Odigeo._.isEmpty(obj.noneButton) && $(this).is(':checked')) {
                    var $noneButton = $cachedSelectors[obj.noneButton] || $(obj.noneButton);
                    $noneButton.prop('disabled', !elem.visible);
                }
            }
        });
    }, this);
};
